import {
  aSignalPage,
  mockEntityDetailsSignalsSummaryQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockEntityDetailsSignalsSummaryQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          allSignals: aSignalPage(),
          prototypeSignals: aSignalPage(),
          suppressedSignals: aSignalPage(),
          unSuppressedSignals: aSignalPage(),
        },
      });
    }
  ),
];
